import { useDispatch, useSelector } from "react-redux";
import { getShowRunHistoryPaneState } from "ee/selectors/workflowRunHistorySelectors";
import React from "react";
import { Button, Tooltip } from "@appsmith/ads";
import { toggleRunHistoryPane } from "ee/actions/workflowRunHistoryActions";
import {
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_HIDE_TOOLTIP,
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_LABEL,
  WORKFLOW_RUN_HISTORY_PANE_TRIGGER_SHOW_TOOLTIP,
  createMessage,
} from "ee/constants/messages";
import { setJsPaneDebuggerState } from "actions/jsPaneActions";
import { setPluginActionEditorDebuggerState } from "PluginActionEditor/store";
import { getIsAiAgentApp } from "ee/selectors/aiAgentSelectors";
import { useDebuggerConfig } from "components/editorComponents/Debugger/hooks/useDebuggerConfig";
import { DEBUGGER_TAB_KEYS } from "components/editorComponents/Debugger/constants";

export function RunHistoryTrigger() {
  const dispatch = useDispatch();
  const paneVisible = useSelector(getShowRunHistoryPaneState);
  const isAiAgentApp = useSelector(getIsAiAgentApp);
  const config = useDebuggerConfig();
  const state = useSelector(config.get);

  const onClick = () => {
    if (isAiAgentApp) {
      const isRunHistoryTabOpen =
        state.open && state.selectedTab === DEBUGGER_TAB_KEYS.RUN_HISTORY_TAB;

      if (isRunHistoryTabOpen) {
        dispatch(config.set({ open: false }));

        return;
      }

      dispatch(
        config.set({
          open: true,
          selectedTab: DEBUGGER_TAB_KEYS.RUN_HISTORY_TAB,
          responseTabHeight: 400,
        }),
      );
    } else {
      dispatch(setJsPaneDebuggerState({ open: false }));
      dispatch(setPluginActionEditorDebuggerState({ open: false }));
      dispatch(toggleRunHistoryPane(!paneVisible));
    }
  };

  const tooltipContent = createMessage(
    !paneVisible
      ? WORKFLOW_RUN_HISTORY_PANE_TRIGGER_SHOW_TOOLTIP
      : WORKFLOW_RUN_HISTORY_PANE_TRIGGER_HIDE_TOOLTIP,
  );

  return (
    <Tooltip content={tooltipContent}>
      <Button
        data-testid="t--workflow-run-history-trigger"
        kind={"tertiary"}
        onClick={onClick}
        size="md"
        startIcon={"history"}
      >
        {createMessage(WORKFLOW_RUN_HISTORY_PANE_TRIGGER_LABEL)}
      </Button>
    </Tooltip>
  );
}
